import { render, staticRenderFns } from "./SendByMailSection.vue?vue&type=template&id=1db5430f&scoped=true&"
import script from "./SendByMailSection.vue?vue&type=script&lang=js&"
export * from "./SendByMailSection.vue?vue&type=script&lang=js&"
import style0 from "./SendByMailSection.vue?vue&type=style&index=0&id=1db5430f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db5430f",
  null
  
)

export default component.exports